import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'

Vue.use(Router)

const EmptyParentComponent = {
  template: '<router-view></router-view>',
}

const demoRoutes = []

if (process.env.NODE_ENV === 'development' || process.env.VUE_APP_INCLUDE_DEMOS) {
  const vueBookRoutes = require('./vueBookRoutes').default
  vueBookRoutes.forEach(route => demoRoutes.push(route))
}

export default new Router({
  mode: 'history',
  routes: [
    ...demoRoutes,
    {
      path: '*',
      redirect: { name: 'login' },
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          name: 'login',
          path: 'login/:externalLink?',
          component: () => import('../components/auth/login/Login.vue'),
        },
        {
          name: 'signup',
          path: 'signup',
          component: () => import('../components/auth/signup/Signup.vue'),
        },
        {
          name: 'recover-password',
          path: 'recover-password',
          component: () => import('../components/auth/recover-password/RecoverPassword.vue'),
        },
        {
          path: '',
          redirect: { name: 'login' },
        },
      ],
    },
    {
      path: '/404',
      component: EmptyParentComponent,
      children: [
        {
          name: 'not-found-advanced',
          path: 'not-found-advanced',
          component: () => import('../components/pages/404-pages/VaPageNotFoundSearch.vue'),
        },
        {
          name: 'not-found-simple',
          path: 'not-found-simple',
          component: () => import('../components/pages/404-pages/VaPageNotFoundSimple.vue'),
        },
        {
          name: 'not-found-custom',
          path: 'not-found-custom',
          component: () => import('../components/pages/404-pages/VaPageNotFoundCustom.vue'),
        },
        {
          name: 'not-found-large-text',
          path: '/pages/not-found-large-text',
          component: () => import('../components/pages/404-pages/VaPageNotFoundLargeText.vue'),
        },
      ],
    },
    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      children: [
        {
          path: 'StudentGraduationProcess',
          name: 'StudentGraduationProcess',
          component: () => import('./../components/StudentGraduation/StudentGraduationProcess.vue'),
        },
        {
          name: 'liquidacionComisiones',
          path: 'liquidacionComisiones',
          component: () => import('./../components/liquidacionComisiones/liquidacionComisiones.vue'),
        },
        {
          name: 'GestionUsuariosPortalEmpleado',
          path: 'GestionUsuariosPortalEmpleado',
          component: () => import('./../components/GestionUsuariosPortalEmpleado/GestionUsuariosPortalEmpleado.vue'),
        },
        {
          name: 'Ordenes',
          path: 'Ordenes',
          component: () => import('./../components/Ordenes/Ordenes.vue'),
        },
        {
          name: 'CalendarioAcademico',
          path: 'CalendarioAcademico',
          component: () => import('./../components/CalendarioAcademico/CalendarioAcademico.vue'),
        },
        {
          name: 'EvalDocenteAdm',
          path: 'EvalDocenteAdm',
          component: () => import('./../components/EvalDocenteAdm/EvalDocenteAdm.vue'),
        },
        {
          name: 'EvalRoles',
          path: 'EvalRoles',
          component: () => import('./../components/EvalRoles/EvalRoles.vue'),
        },
        {
          name: 'EvalPercent',
          path: 'EvalPercent',
          component: () => import('./../components/EvalPercent/EvalPercent.vue'),
        },
        {
          name: 'Metas',
          path: 'Metas',
          component: () => import('./../components/GoalsProyection/Goals.vue'),
          default: true,
        },
        {
          name: 'dashboard',
          path: 'dashboard/:externalLink?',
          component: () => import('../components/dashboard/Dashboard.vue'),
          default: true,
        },
        {
          name: 'DataUpdate',
          path: 'DataUpdate',
          component: () => import('@/components/DataUpdate/DataUpdate.vue'),
          default: true,
        },
        {
          name: 'account',
          path: 'account',
          component: () => import('@/components/DataUpdate/Account.vue'),
        },
        {
          name: 'mserrorlogin',
          path: 'mserrorlogin',
          component: () => import('@/components/DataUpdate/mserrorlogin.vue'),
        },
        {
          name: 'OrderEnroll',
          path: 'OrderEnroll',
          component: () => import('@/components/OrderEnroll/OrderEnroll.vue'),
          default: true,
        },
        {
          name: 'OrderEnrollStatus',
          path: 'OrderEnrollStatus',
          component: () => import('@/components/OrderEnroll/OrderEnrollStatus.vue'),
          default: true,
        },
        {
          name: 'BulkInscription',
          path: 'BulkInscription',
          component: () => import('@/components/Inscriptions/BulkInscription.vue'),
          default: true,
        },
        {
          name: 'formulario-inscripcion',
          path: 'formulario-inscripcion',
          component: () => import('@/components/Inscriptions/formulario-inscripcion.vue'),
          default: true,
        },
        {
          path: '/archivos-inscripcion/:docType?/:docNum?/:celNum?/:mailRef?',
          name: 'InscripcionFiles',
          meta: { title: 'Inscripción de Documentos' },
          component: () =>
            import('@/components/Inscriptions/InscripcionFiles.vue'),
        },
        {
          name: 'Voting',
          path: 'Voting',
          component: () => import('@/components/Voting/Voting.vue'),
          default: true,
        },
        {
          name: 'Manualdemarca',
          path: 'Manualdemarca',
          component: () => import('@/components/Voting/ManualMarca.vue'),
          default: true,
        },
        {
          name: 'EvalAdministrative',
          path: 'EvalAdministrative',
          component: () => import('@/components/EvalAdministrative/EvalAdministrative.vue'),
          default: true,
        },
        {
          name: 'Menu',
          path: 'Menu',
          component: () => import('@/components/Menu/Menu.vue'),
          default: true,
        },
        {
          name: 'SubMenu',
          path: 'SubMenu/:idMenu/:nameMenu',
          component: () => import('@/components/Menu/MenuSub.vue'),
          default: true,
        },
        {
          name: 'RolAccess',
          path: 'RolAccess',
          component: () => import('@/components/Roles/RolesByMenu.vue'),
          default: true,
        },
        {
          name: 'Users',
          path: 'Users',
          component: () => import('@/components/Users/Users.vue'),
          default: true,
        },
        {
          name: 'Programs',
          path: 'Programs',
          component: () => import('@/components/Programs/Programs.vue'),
          default: true,
        },
        {
          name: 'CertificateType',
          path: 'CertificateType',
          component: () => import('@/components/CertificateType/CertificateType.vue'),
        },
        {
          name: 'Periods',
          path: 'Periods',
          component: () => import('@/components/Periods/Periods.vue'),
          default: true,
        },
        {
          name: 'ProgramPlan',
          path: 'ProgramPlan',
          component: () => import('@/components/Programs/ProgramPlan.vue'),
          default: true,
        },
        {
          name: 'CalendarioA',
          path: 'CalendarioA',
          component: () => import('@/components/CalendarioA/CalendarioA.vue'),
          default: true,
        },
        {
          name: 'RenewalPermanence',
          path: 'RenewalPermanence',
          component: () => import('@/components/Permanence/RenewalPermanence.vue'),
          default: true,
        },
        {
          name: 'operatorprogram',
          path: 'operatorprogram',
          component: () => import('@/components/operatorprogram/operatorprogram.vue'),
          default: true,
        },
        {
          name: 'periodprogram',
          path: 'periodprogram',
          component: () => import('@/components/periodprogram/periodprogram.vue'),
          default: true,
        },
        {
          name: 'EvalDocente',
          path: 'EvalDocente',
          component: () => import('@/components/EvalDocente/EvalDocente.vue'),
          default: true,
        },
        {
          name: 'FormEvalDocente',
          path: 'FormEvalDocente',
          component: () => import('@/components/EvalDocente/FormEvalDocente.vue'),
          default: true,
        },
        {
          name: 'AutoEvaluacion',
          path: 'AutoEvaluacion',
          component: () => import('@/components/AutoEvaluacion/AutoEvaluacion.vue'),
          default: true,
        },
        {
          name: 'TeacherHours',
          path: 'TeacherHours',
          component: () => import('@/components/AutoEvaluacion/TeacherHours.vue'),
          default: true,
        },
        {
          name: 'FormAutoEvaluation',
          path: 'FormAutoEvaluation',
          component: () => import('@/components/AutoEvaluacion/FormAutoEvaluation.vue'),
          default: true,
        },
        {
          name: 'EvalDirector',
          path: 'EvalDirector',
          component: () => import('@/components/EvalDirector/EvalDirector.vue'),
          default: true,
        },
        {
          name: 'FormEvalDirector',
          path: 'FormEvalDirector',
          component: () => import('@/components/EvalDirector/FormEvalDirector.vue'),
          default: true,
        },
        {
          name: 'ConfigCases',
          path: 'ConfigCases',
          component: () => import('@/components/Cases/ConfigCases.vue'),
          default: true,
        },
        {
          name: 'CreateCase',
          path: 'CreateCase/:idCase',
          component: () => import('@/components/Cases/CreateCase.vue'),
          default: true,
        },
        {
          name: 'UpdateCase',
          path: 'UpdateCase/:id',
          component: () => import('@/components/Cases/UpdateCase.vue'),
          default: true,
        },
        {
          name: 'ReportCases',
          path: 'ReportCases',
          component: () => import('@/components/Cases/ReportCases.vue'),
          default: true,
        },
        {
          name: 'ReportOrdenes',
          path: 'ReportOrdenes',
          component: () => import('@/components/Reports/ReportOrdenes.vue'),
          default: true,
        },
        {
          name: 'ReportSaberPRO',
          path: 'ReportSaberPRO',
          component: () => import('@/components/Reports/ReportSaberPRO.vue'),
          default: true,
        },
        {
          name: 'ReportSaberPRO2023',
          path: 'ReportSaberPRO2023',
          component: () => import('@/components/Reports/ReportSaberPRO2023.vue'),
          default: true,
        },
        {
          name: 'ReportAnalisisEstrategicoSaberPro',
          path: 'ReportAnalisisEstrategicoSaberPro',
          component: () => import('@/components/Reports/ReportAnalisisEstrategicoSaberPro.vue'),
          default: true,
        },
        {
          name: 'ReportCaracterizacion',
          path: 'ReportCaracterizacion',
          component: () => import('@/components/Reports/ReportCaracterizacion.vue'),
          default: true,
        },
        {
          name: 'ReportAporteRelativo',
          path: 'ReportAporteRelativo',
          component: () => import('@/components/Reports/ReportAporteRelativo.vue'),
          default: true,
        },
        {
          name: 'ReportValorAgregado',
          path: 'ReportValorAgregado',
          component: () => import('@/components/Reports/ReportValorAgregado.vue'),
          default: true,
        },
        {
          name: 'ReportSaberTyT',
          path: 'ReportSaberTyT',
          component: () => import('@/components/Reports/ReportSaberTyT.vue'),
          default: true,
        },
        {
          name: 'ReportOrdenesGeneradas',
          path: 'ReportOrdenesGeneradas',
          component: () => import('@/components/Reports/ReportOrdenesGeneradas.vue'),
          default: true,
        },
        {
          name: 'AccesoAMoocReports',
          path: 'AccesoAMoocReports',
          component: () => import('@/components/Reports/AccesoAMoocReports.vue'),
          default: true,
        },
        {
          name: 'AccesoPlataformaReports',
          path: 'AccesoPlataformaReports',
          component: () => import('@/components/Reports/AccesoPlataformaReports.vue'),
          default: true,
        },
        {
          name: 'Characterization',
          path: 'Characterization',
          component: () => import('@/components/Characterization/Characterization.vue'),
          default: true,
        },
        {
          name: 'ReportCharacterization',
          path: 'ReportCharacterization',
          component: () => import('@/components/Characterization/ReportCharacterization.vue'),
          default: true,
        },
        {
          name: 'HistoryCharacterization',
          path: 'HistoryCharacterization/:idCaract',
          component: () => import('@/components/Characterization/HistoryCharacterization.vue'),
          default: true,
        },
        {
          name: 'FormCharacterization',
          path: 'FormCharacterization/:idCaract',
          component: () => import('@/components/Characterization/FormCharacterization.vue'),
          default: true,
        },
        {
          name: 'ReportCharactData',
          path: 'ReportCharactData/:idReference/:idCaract',
          component: () => import('@/components/Characterization/ReportCharactData.vue'),
          default: true,
        },
        {
          name: 'ReportShortCourses',
          path: 'ReportShortCourses',
          component: () => import('@/components/ShortCourses/ReportShortCourses.vue'),
          default: true,
        },
        {
          name: 'ReportShortCourseData',
          path: 'ReportShortCourseData/:idCourse',
          component: () => import('@/components/ShortCourses/ReportShortCourseData.vue'),
          default: true,
        },
        {
          name: 'SummaryRegistrationForm',
          path: 'SummaryRegistrationForm/:id',
          component: () => import('@/components/Reports/SummaryRegistrationForm.vue'),
          default: true,
        },
        {
          name: 'Operator',
          path: 'Operator/:Area',
          component: () => import('@/components/Operators/Operator.vue'),
          default: true,
        },
        {
          name: 'SIAC',
          path: 'SIAC/:Area',
          component: () => import('@/components/SIAC/SIAC.vue'),
          default: true,
        },
        {
          name: 'OperatorReports',
          path: 'OperatorReports/:Report',
          component: () => import('@/components/Operators/OperatorReports.vue'),
          default: true,
        },
        {
          name: 'OperatorCommissions',
          path: 'OperatorCommissions/:Report',
          component: () => import('@/components/Operators/OperatorCommissions.vue'),
          default: true,
        },
        {
          name: 'OperatorReportsIcetex',
          path: 'OperatorReportsIcetex',
          component: () => import('@/components/Operators/OperatorReportsIcetex.vue'),
          default: true,
        },
        {
          name: 'OperatorDataUpdate',
          path: 'OperatorDataUpdate',
          component: () => import('@/components/Operators/OperatorDataUpdate.vue'),
          default: true,
        },
        {
          name: 'Mailing',
          path: 'Mailing',
          component: () => import('@/components/Mailing/Mailing.vue'),
          default: true,
        },
        {
          name: 'FeedBackForm',
          path: 'FeedBackForm/:idMonitor?/:idArea?',
          component: () => import('@/components/FeedBack/FeedBackForm.vue'),
          default: true,
        },
        {
          name: 'FeedBackList',
          path: 'FeedBackList',
          component: () => import('@/components/FeedBack/FeedBackList.vue'),
          default: true,
        },
        {
          name: 'GradesList',
          path: 'GradesList',
          component: () => import('@/components/Grades/GradesList.vue'),
          default: true,
        },
        {
          name: 'InscriptionGrades',
          path: 'InscriptionGrades',
          component: () => import('@/components/Grades/FormGrades.vue'),
          default: true,
        },
        {
          name: 'Report_Grades',
          path: 'Report_Grades',
          component: () => import('@/components/Grades/InscriptionGradeList.vue'),
          default: true,
        },
        {
          name: 'BulkCertificate',
          path: 'BulkCertificate',
          component: () => import('@/components/Xertify/BulkCertificate.vue'),
          default: true,
        },
        {
          name: 'ReloadCredits',
          path: 'ReloadCredits',
          component: () => import('@/components/Credits/ReloadCredits.vue'),
          default: true,
        },
        {
          name: 'GenerateBadge',
          path: 'GenerateBadge',
          component: () => import('@/components/Badge/GenerateBadge.vue'),
          default: true,
        },
        {
          name: 'BadgeIMF',
          path: 'BadgeIMF',
          component: () => import('@/components/Badge/BadgeIMF.vue'),
          default: true,
        },
        {
          name: 'ImmediateBossesAdm',
          path: 'ImmediateBossesAdm',
          component: () => import('@/components/EvalDocenteAdm/ImmediateBossesAdm.vue'),
          default: true,
        },
        {
          name: 'TeachersAdm',
          path: 'TeachersAdm',
          component: () => import('@/components/EvalDocenteAdm/TeachersAdm.vue'),
          default: true,
        },
        {
          name: 'statistics',
          path: 'statistics',
          component: EmptyParentComponent,
          children: [
            {
              name: 'charts',
              path: 'charts',
              component: () => import('../components/statistics/charts/Charts.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Charts',
              },
            },
            {
              name: 'progress-bars',
              path: 'progress-bars',
              component: () => import('../components/statistics/progress-bars/ProgressBars.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Progress-Bars',
              },
            },
          ],
        },
        {
          name: 'forms',
          path: 'forms',
          component: EmptyParentComponent,
          children: [
            {
              name: 'form-elements',
              path: 'form-elements',
              component: () => import('../components/forms/form-elements/FormElements.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/inputs',
              },
            },
            {
              name: 'medium-editor',
              path: 'medium-editor',
              component: () => import('../components/forms/medium-editor/MediumEditor.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Medium-Editor',
              },
            },
          ],
        },
        {
          name: 'tables',
          path: 'tables',
          component: EmptyParentComponent,
          children: [
            {
              name: 'markup',
              path: 'markup',
              component: () => import('../components/markup-tables/MarkupTables.vue'),
              wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Tables', // TODO Update docs
            },
            {
              name: 'data',
              path: 'data',
              component: () => import('../components/data-tables/DataTables.vue'),
              wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Tables', // TODO Add docs
            },
          ],
        },
        {
          name: 'ui',
          path: 'ui',
          component: EmptyParentComponent,
          children: [
            {
              name: 'typography',
              path: 'typography',
              component: () => import('../components/ui/typography/Typography.vue'),
            },
            {
              name: 'buttons',
              path: 'buttons',
              component: () => import('../components/ui/buttons/Buttons'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Buttons',
              },
            },
            {
              name: 'rating',
              path: 'rating',
              component: () => import('../components/ui/rating/Rating'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Rating',
              },
            },
            {
              name: 'color-pickers',
              path: 'color-pickers',
              component: () => import('../components/ui/color-pickers/ColorPickers'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Color-Pickers',
              },
            },
            {
              name: 'timelines',
              path: 'timelines',
              component: () => import('../components/ui/timelines/Timelines'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Timelines',
              },
            },
            {
              name: 'notifications',
              path: 'notifications',
              component: () => import('../components/ui/notifications/Notifications'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Notifications',
              },
            },
            {
              path: 'icons',
              component: () => import('../components/ui/icons/Icons'),
              children: [
                {
                  name: 'icon-sets',
                  path: '', // Default route
                  component: () => import('../components/ui/icons/SetsList'),
                  meta: {
                    wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Icons',
                  },
                },
                {
                  name: 'icon-set',
                  path: ':name',
                  component: () => import('../components/ui/icons/IconSet'),
                  props: true,
                  meta: {
                    wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Icons',
                  },
                },
              ],
            },
            {
              name: 'spinners',
              path: 'spinners',
              component: () => import('../components/ui/spinners/Spinners'),
            },
            {
              name: 'grid',
              path: 'grid',
              component: () => import('../components/ui/grid/Grid'),
            },
            {
              name: 'modals',
              path: 'modals',
              component: () => import('../components/ui/modals/Modals'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Modals',
              },
            },
            {
              name: 'cards',
              path: 'cards',
              component: () => import('../components/ui/cards/Cards'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Cards',
              },
            },
            {
              name: 'file-upload',
              path: 'file-upload',
              component: () => import('../components/ui/file-upload/FileUpload'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/File-Upload',
              },
            },
            {
              name: 'chips',
              path: 'chips',
              component: () => import('../components/ui/chips/Chips'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Chips',
              },
            },
            {
              name: 'tree-view',
              path: 'tree-view',
              component: () => import('../components/ui/tree-view/TreeView'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Tree-view',
              },
            },
            {
              name: 'collapses',
              path: 'collapses',
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Collapse',
              },
              component: () => import('../components/ui/collapse/Collapses'),
            },
            {
              name: 'colors',
              path: 'colors',
              component: () => import('../components/ui/colors/Colors'),
            },
            {
              name: 'spacing',
              path: 'spacing',
              component: () => import('../components/ui/spacing/Spacing'),
            },
            {
              name: 'sliders',
              path: 'sliders',
              component: () => import('../components/ui/sliders/Sliders'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Sliders',
              },
            },
            {
              name: 'popovers',
              path: 'popovers',
              component: () => import('../components/ui/popovers/Popovers'),
            },
            {
              name: 'chat',
              path: 'chatPage',
              component: () => import('../components/ui/chat/ChatPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Chat',
              },
            },
            {
              name: 'tabs',
              path: 'tabs',
              component: () => import('../components/ui/tabs/Tabs'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Tabs',
              },
            },
            {
              name: 'lists',
              path: 'lists',
              component: () => import('../components/lists/Lists.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Lists',
              },
            },
          ],
        },
        {
          name: 'maps',
          path: 'maps',
          component: EmptyParentComponent,
          children: [
            {
              name: 'google-maps',
              path: 'google-maps',
              component: () => import('../components/maps/google-maps/GoogleMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
            {
              name: 'yandex-maps',
              path: 'yandex-maps',
              component: () => import('../components/maps/yandex-maps/YandexMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
            {
              name: 'leaflet-maps',
              path: 'leaflet-maps',
              component: () => import('../components/maps/leaflet-maps/LeafletMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
            {
              name: 'bubble-maps',
              path: 'bubble-maps',
              component: () => import('../components/maps/bubble-maps/BubbleMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
            {
              name: 'line-maps',
              path: 'line-maps',
              component: () => import('../components/maps/line-maps/LineMapsPage'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Maps',
              },
            },
          ],
        },
        {
          name: 'pages',
          path: 'pages',
          component: EmptyParentComponent,
          children: [
            {
              name: '404-pages',
              path: '404-pages',
              component: () => import('../components/pages/404-pages/404PagesPage'),
            },
          ],
        },
      ],
    },
  ],
})
